import React from 'react';
import { Form, Input, FormInstance } from 'antd';
import { VipSuppIdFormData } from '../types';
import { FORM_DEFAULT_VALUES } from '../constants';

interface VipSuppIdFormProps {
  form: FormInstance<VipSuppIdFormData>;
  isEdit?: boolean;
}

const VipSuppIdForm: React.FC<VipSuppIdFormProps> = ({ form, isEdit = false }) => {
  return (
    <Form form={form} layout="vertical" initialValues={FORM_DEFAULT_VALUES}>
      <Form.Item
        name="beautifulNumber"
        label="VIP SUPPID"
        rules={[
          { required: true, message: '请输入 VIP SUPPID' },
          {
            pattern: /^\d+$/,
            message: 'VIP SUPPID 必须为纯数字',
          },
          {
            validator: async (_, value) => {
              if (!value) {
                return Promise.resolve();
              }
              const numValue = String(value).trim();
              if (numValue.length < 6 || numValue.length > 11) {
                return Promise.reject(new Error('VIP SUPPID 必须为 6-11 位数字'));
              }
              // 这里可以添加去重校验，需要调用 API 检查是否已存在
              // 暂时先通过后端返回错误信息来处理
              return Promise.resolve();
            },
          },
        ]}
      >
        <Input
          placeholder="请输入 VIP SUPPID（6-11 位纯数字）"
          maxLength={11}
        />
      </Form.Item>
    </Form>
  );
};

export default VipSuppIdForm;

